<template>
  <div>
    <Accordion
      :is-open="false"
      class="pega-visible"
    >
      <template #head>
        さらに絞り込む
      </template>
      <template #body>
        <div class="boss-table-2">
          <scout-form-scouted-date v-bind.sync="filterData.sendDate" />
          <scout-form-member-id
            v-model.number="filterData.userId"
            half
          />
          <scout-form-scouted-count
            v-model="filterData.sendCount"
            half
          />
          <scout-form-pull-down
            v-model="filterData.readingStatus"
            :options="readingStatusOptions"
            label="スカウト閲覧状態"
            half
            data-test="reading-status"
          />
          <scout-form-pull-down
            v-model="filterData.searchConditionName"
            :options="searchConditionNames"
            label="検索条件名"
            half
            data-test="search-condition-name"
          />
          <scout-form-pull-down
            v-model="filterData.subject"
            :options="subjects"
            label="スカウト件名"
            half
            data-test="subject"
          />
          <scout-form-pull-down
            v-model="filterData.reservedInfo"
            :options="reservedInfos"
            label="スカウト予約"
            half
            data-test="reserve-info"
          />
          <scout-form-gender
            v-model="filterData.gender"
            half
          />
          <scout-form-employed
            v-model="filterData.employed"
            half
          />
          <scout-form-prefecture
            v-if="renderModal"
            :prefectures.sync="filterData.address.prefectures"
            :cities.sync="filterData.address.cities"
            label="現住所"
          />
          <scout-form-educational-background v-model="filterData.educationalBackground" />
          <scout-form-others
            :includes-resend.sync="filterData.isResendable"
            half
            v-bind.sync="filterData"
          />
          <scout-form-special-favor v-model="filterData.specialFavorIds" />
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Accordion from '@/components/atoms/Accordion'
import * as definition from '@/lib/labelValueMappings'
import scoutMemberFilterUtil from '@/lib/scoutMemberFilterUtil'
import _ from 'lodash'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormScoutedDate from '@/components/atoms/ScoutFormScoutedDate'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormScoutedCount from '@/components/atoms/ScoutFormScoutedCount'
import ScoutFormPullDown from '@/components/atoms/ScoutFormPullDown'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'
import ScoutFormSpecialFavor from '@/components/atoms/ScoutFormSpecialFavor'

export default {
  components: {
    Accordion,
    ScoutFormEducationalBackground,
    ScoutFormEmployed,
    ScoutFormGender,
    ScoutFormScoutedDate,
    ScoutFormMemberId,
    ScoutFormScoutedCount,
    ScoutFormPullDown,
    ScoutFormPrefecture,
    ScoutFormOthers,
    ScoutFormSpecialFavor
  },
  mixins: [scoutMemberFilterUtil],
  props: {
    memberObjects: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      isScouted: true, // mixinの処理切り替え用
      readingStatusOptions: definition.readingStatus // 1: 既読 2: 未読
    }
  },
  computed: {
    subjects () {
      return _(this.memberObjects).map(_.property('member.scout.latestMessage.subject')).uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    },
    reservedInfos () {
      return _(this.memberObjects).map(_.property('member.reservationLogs')).flattenDeep().uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'prefectures',
      'specialFavors'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
  },
  methods: {
    ...mapActions({
      storeMaster: 'storeMaster'
    })
  }
}
</script>
